<template>
  <div v-if="app.isFirebaseLoaded" id="root" class="app">
    <mc-global-loader />
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['app'])
  }
};
</script>

<style lang="scss" scoped>
#root {
  height: 100%;
}

.app {
  &__loading {
    background-color: $dark-theme-color;
  }
}
</style>

<style lang="scss">
@import '~bulma/sass/utilities/_all';
@import './styles/overrides';

// Import Bulma and Buefy styles
@import '~bulma';
@import '~buefy/src/scss/buefy';

body,
html {
  height: 100%;
}

body {
  line-height: 1rem;
  margin: 0;
  padding: 0;
}

// Override bulma styles

.switch:not(.default) {
  position: relative;
  flex-direction: row-reverse;
  justify-content: space-between;

  .control-label {
    padding-left: 0;
    padding-right: 0.5rem;
  }
}

// Fixes material-design-icons alignment issue
.mdi {
  display: inline-flex;
}

.mc-container {
  max-width: $container-max-width;
  width: 100%;
  margin: 0 auto;
}

// Vue select style overrides
.v-select {
  background-color: #ffffff;
  box-shadow: $input-shadow;

  .vs__selected {
    .content {
      margin-bottom: 0;
    }
  }
}

// Vue datetime style overrides
.vdatetime {
  .vdatetime-popup__header,
  .vdatetime-calendar__month__day--selected > span > span,
  .vdatetime-calendar__month__day--selected:hover > span > span {
    background-color: $theme-color;
  }

  .vdatetime-year-picker__item--selected,
  .vdatetime-month-picker__item--selected,
  .vdatetime-time-picker__item--selected,
  .vdatetime-popup__actions__button {
    color: $theme-color;
  }
}
</style>
